import { Container, Row, Col } from "react-bootstrap";
import emo_category_icon from "../../images/emo_category.png";
import FEAI_icon from "../../images/FEAI_icon.png";
import Learning_AI from "../../images/learning_ai.png";
import fer2013_sneak_peak from "../../images/fer2013_sneak_peak.png";
import fer2013_distributions from "../../images/fer2013_distributions.png";
import MouseHoverInfoTooltip from "./MouseHoverInfoTooltip";
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import affectnet_sample from "../../images/affectnet_sample.png"
import Thinking_AI from "../../images/AI_thinking.png"

import ResNet50ArchitectureTooltip from "./ResNet50ArchitectureTooltip";
import icon_one from "../../images/introPageIcon.png"
import icon_two from "../../images/introPageIcon2.png"
import icon_three from "../../images/introPageIcon3.png"
import icon_step_one from "../../images/step_one.png"
import icon_step_two from "../../images/step_two.png"
import icon_step_three from "../../images/step-three.png"
import icon_step_four from "../../images/step-four.png"
import gradcam_sample from "../../images/gradcam.png";
import guided_gradcam_sample from "../../images/guided_gradcam.png";
import dataset_explain from "../../images/dataset_explain.jpg"

import './StudyOneInstruction.css'
import { steps } from "framer-motion";

const rootStyles = getComputedStyle(document.documentElement);
const data = [
    { name: 'Surprise', value: 5.0 },
    { name: 'Sad', value: 8.9 },
    { name: 'Happy', value: 46.3},
    { name: 'Fear', value: 2.4 },
    { name: 'Disgust', value: 1.5},
    { name: 'Angry', value: 8.7 },
    { name: 'contempt', value: 1.5 },
    { name: 'Neutral', value: 25.9 },
  ];

const COLORS = [
    rootStyles.getPropertyValue('--surprised-color').trim(),  
    rootStyles.getPropertyValue('--sad-color').trim(),        
    rootStyles.getPropertyValue('--happy-color').trim(),      
    rootStyles.getPropertyValue('--fearful-color').trim(),    
    rootStyles.getPropertyValue('--disgusted-color').trim(),  
    rootStyles.getPropertyValue('--angry-color').trim(), 
    rootStyles.getPropertyValue('--contempt-color').trim(),      
    rootStyles.getPropertyValue('--neutral-color').trim(),    
  ];
  const renderCustomLabel = ({ percent, name, value }) => {
    return `${value}%`;
  };

export default function StudyOneInstructionPageOne(){
    return (
        <Container className="study-item">
            <Row >
                <h1 style={{ fontWeight: 'bold'}}>How does FEAI learn to read emotions?</h1>
                <br /><br /><br />
            <Row className="align-items-start mb-4">
                <Col xs={4} className="text-center">
                    <img 
                        src={Learning_AI} 
                        alt="FEAI icon" 
                        style={{ width: "200px", height: "200px", borderRadius: "50%" }} 
                    />
                </Col>
                <Col xs={6}>
                <div className="chat-bubble">
                    <p>
                    We have textbooks:<strong className="highlight"> Dataset</strong>.
                    </p>
                </div>
                </Col>
            </Row>
                <h1 className="subtitle">What's dataset for FEAI?</h1>

                <Container style={{width:"90%"}}>
                    <p>People extract facial expressions from various visual materials, 
                        such as movies and photographs, and label these expressions (See <strong>Figure 1</strong>)</p>
                        <figure style={{ width: "80%", margin: "0 auto" }}>
                            <img src={dataset_explain} alt="" style={{ width: "100%" }} />
                            <figcaption style={{ textAlign: "center", fontSize: "medium", fontWeight: "bold" }}>
                                Figure 1
                            </figcaption>
                        </figure>
                    <p>Millions of such labeled facial expressions form a dataset—essentially the textbook for FEAI. Figure 2 shows a sample of that</p>
                    <figure style={{ width: "80%", margin: "0 auto" }}>
                        <img src={affectnet_sample} alt="" style={{width:"100%"}}/>
                        <figcaption style={{textAlign:"center", fontSize:"medium", fontWeight:"bold"}}>Figure 2</figcaption>
                    </figure>

                </Container>
                <Container>
                <br /><br />
                <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={Thinking_AI} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", }} 
                            />
                        </Col>
                        <Col xs={6}>
                        <div className="chat-bubble">
                            <p>
                            Usually, we don’t know who labeled these photos.
                            </p>
                        </div>
                        </Col>
                    </Row>                   
                </Container>
            </Row>
        </Container>
    );
};